import styled from '@emotion/styled'
import { themeUtils } from 'styles/theme'

export const SpacedDash = styled.span`
  margin: 0 5px;
  &::before {
    content: '-';
  }

  ${themeUtils.maxWidth.sm} {
    display: none;
  }
`

export const SeoStatsContainer = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: row;
  ${themeUtils.maxWidth.sm} {
    flex-direction: column;
    margin-top: 10px;
  }
`

export const SeoTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`
